module.exports = __webpack_public_path__ + "img/b.e3cd729d.png";